import React, { useState, useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Grid from '@material-ui/core/Grid';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import {
  FaPrint,
  FaRegArrowAltCircleRight,
  FaRegArrowAltCircleLeft,
  FaRegCheckSquare,
  FaBan,
} from 'react-icons/fa';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ModalAtender from './ModalAtender';
import { dominioBackend } from '../../config/database';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/geral.css';
import 'assets/css/bim.css';

export default function BIM() {
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [statusSelecionado, setStatusSelecionado] = useState(null);
  const [requisicoes, setRequisicoes] = useState([]);
  const [listaStatus, setListaStatus] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const [dateRange, setDateRange] = useState(() => {
    const dataFinal = new Date();
    const dataInicial = new Date();
    dataInicial.setDate(dataInicial.getDate() - 7);
    return [dataInicial, dataFinal];
  });
  const [openDialogAtender, setOpenDialogAtender] = useState(false);
  const [openDialogRecusar, setOpenDialogRecusar] = useState(false);
  const [requisicaoSelecionada, setRequisicaoSelecionada] = useState(null);
  const [almoxarifadoSelecionado, setAlmoxarifadoSelecionado] = useState(null);
  const [openMotivoRecusa, setOpenMotivoRecusa] = useState(false);
  const [rowSelecionado, setRowSelecionado] = useState(null);
  const [motivoRecusa, setMotivoRecusa] = useState('');
  const profissional = JSON.parse(localStorage.getItem('profissional'));
  const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
  const dt = useRef(null);
  const myToast = useRef(null);
  const [selectedDateInclusao, setSelectedDateInclusao] = useState(null);

  const formatDate = date => {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = `0${month}`;
    }

    if (day < 10) {
      day = `0${day}`;
    }

    return `${date.getFullYear()}-${month}-${day}`;
  };

  const listarStatus = () => {
    dominioBackend.get(`/api/status`).then(res => {
      setListaStatus(res.data.map(status => status.descricao));
    });
  };

  const filterDate = (value, filter) => {
    if (
      filter === undefined ||
      filter === null ||
      (typeof filter === 'string' && filter.trim() === '')
    ) {
      return true;
    }
  };

  const listarRequisicoes = () => {
    setLoading(true);
    dominioBackend
      .get(
        `/api/requisicaoBIMPorAlmoxarifado/${almoxarifadoSelecionado.id}?initialDate=${formatDate(
          dateRange[0]
        )}&finalDate=${formatDate(dateRange[1])}`
      )
      .then(
        res => {
          setRequisicoes(res.data);
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
  };

  const entregarRequisicao = idRequisicao => {
    dominioBackend.put(`/api/entregarRequisicao/${idRequisicao}/${profissional.userId}`).then(
      () => {
        myToast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Requisição entregue com sucesso!',
          life: '3000',
        });
      },
      () => {
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção!',
          detail: `Erro ao entregar requisição!`,
          life: '3000',
        });
      }
    );
  };

  const handleRecusarRequisicao = () => {
    if (motivoRecusa.length < 3) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Insira um motivo de recusa válido!',
        life: '3000',
      });
      return;
    }
    const data = {
      motivoRecusa,
    };

    dominioBackend
      .put(`/api/recusarRequisicao/${requisicaoSelecionada.id}/${profissional.userId}`, data)
      .then(
        () => {
          myToast.current.show({
            severity: 'success',
            summary: 'Sucesso!',
            detail: 'Requisição recusada com sucesso!',
            life: '3000',
          });
        },
        () => {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção!',
            detail: `Erro ao recusar requisição!`,
            life: '3000',
          });
        }
      )
      .finally(() => {
        setOpenDialogRecusar(false);
        setMotivoRecusa('');
        listarRequisicoes();
      });
  };

  const handleSepararRequisicao = data => {
    // data.id equivale a requisisaoSelecionada.id
    dominioBackend
      .put(`/api/separarRequisicao/${data.id}/${profissional.userId}`, data)
      .then(
        () => {
          myToast.current.show({
            severity: 'success',
            summary: 'Sucesso!',
            detail: 'Requisição em separação!',
            life: '3000',
          });
        },
        () => {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção!',
            detail: `Erro ao separar a requisição!`,
            life: '3000',
          });
        }
      )
      .finally(() => {
        listarRequisicoes();
      });
  };

  useEffect(() => {
    listarStatus();
    setAlmoxarifadoSelecionado(profissional.almoxarifadosProfissional[0]);
  }, []);

  useEffect(() => {
    if (almoxarifadoSelecionado) {
      listarRequisicoes();
    }
  }, [almoxarifadoSelecionado]);

  useEffect(() => {
    if (almoxarifadoSelecionado && dateRange && dateRange[0] && dateRange[1]) {
      listarRequisicoes();
    }
  }, [dateRange, almoxarifadoSelecionado]);

  const closeDialogAtender = () => {
    setRequisicaoSelecionada(null);
    setOpenDialogAtender(false);
    listarRequisicoes();
  };

  const solicitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Solicitante</span>
        <span>{rowData.solicitante}</span>
      </>
    );
  };

  const dataBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data</span>
        <span>{new Date(rowData.pedidoEm).toLocaleDateString()}</span>
      </>
    );
  };

  const statusBodyTemplate = rowData => {
    return (
      <div>
        <span>{rowData.status}</span>
      </div>
    );
  };

  const numeroBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nº Requisição</span>
        <span>{rowData.numero}</span>
      </>
    );
  };

  const reqPaiBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Req. Pai</span>
        <span>{rowData.requisicaoPai ? rowData.requisicaoPai.numero : ''}</span>
      </>
    );
  };

  const acoesBodyTemplate = rowData => {
    return (
      <div style={{ textAlign: 'center' }} className="div-acoes">
        <Toast ref={myToast} />
        <span className="p-column-title">Ações</span>
        <Tooltip title="Motivo de recusa">
          <IconButton
            onClick={() => {
              setOpenMotivoRecusa(true);
              setRowSelecionado(rowData);
            }}
            style={{
              display: 'inherit',
              backgroundColor: 'red',
            }}
            className={`botao-alinhado-esquerda ${rowData.statusId === configuracoes.statusRecusado ? null : 'invisivel'
              }`}
          >
            <FaBan color="white" size={18} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Recusar">
          <IconButton
            onClick={() => {
              setRequisicaoSelecionada(rowData);
              setOpenDialogRecusar(true);
            }}
            color="inherit"
            style={{ backgroundColor: '#c90000ff' }}
            className={`botao-alinhado-esquerda ${rowData.statusId !== configuracoes.statusEmPendencia ? 'invisivel' : null
              }`}
          >
            <FaRegArrowAltCircleLeft color="white" size={18} />
          </IconButton>
        </Tooltip>
        {/* Chamado: 2026050241 */}
        {/* <Tooltip title="Em Separação">
          <IconButton
            onClick={async () => {
              await dominioBackend().then(promise => {
                window.open(`${promise.config.baseURL}/boletimEntrega/${rowData.id}`);
              });
              handleSepararRequisicao(rowData);
            }}
            color="inherit"
            style={{ backgroundColor: '#2196F3' }}
            className={`botao-alinhado-esquerda ${rowData.statusId === configuracoes.statusEmPendencia ||
                rowData.statusId === configuracoes.statusEmSeparacao
                ? null
                : 'invisivel'
              }`}
          >
            <FaPrint color="white" size={14} />
          </IconButton>
        </Tooltip> */}
        <Tooltip title="Atender">
          <IconButton
            onClick={() => {
              setRequisicaoSelecionada(rowData);
              setOpenDialogAtender(true);
            }}
            color="inherit"
            style={{ backgroundColor: '#28a745' }}
            className={`botao-alinhado-esquerda ${rowData.statusId !== configuracoes.statusEmPendencia ? 'invisivel' : null
              }`}
          >
            <FaRegArrowAltCircleRight color="white" size={18} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Boletim de entrega">
          <IconButton
            onClick={async () => {
              await dominioBackend().then(promise => {
                window.open(`${promise.config.baseURL}/boletimEntrega/${rowData.id}`);
              });
              listarRequisicoes();
            }}
            color="inherit"
            style={{ backgroundColor: '#6c757d' }}
            className={`botao-alinhado-esquerda ${rowData.statusId === configuracoes.statusEmPendencia ||
                rowData.statusId === configuracoes.statusRecusado ||
                rowData.statusId === configuracoes.statusEmSeparacao
                ? 'invisivel'
                : null
              }`}
          >
            <FaPrint color="white" size={14} />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title="Entregar">
          <IconButton
            onClick={() => {
              entregarRequisicao(rowData.id);
              listarRequisicoes();
            }}
            color="inherit"
            style={{ backgroundColor: '#007bff' }}
            className={`botao-alinhado-esquerda ${!rowData.impressoEm || rowData.entregueEm ? 'invisivel' : null
            }`}
          >
            <FaRegCheckSquare color="white" size={14} />
          </IconButton>
        </Tooltip> */}
      </div>
    );
  };

  const codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        <span>{rowData.codigo}</span>
      </>
    );
  };

  const nomeBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nome</span>
        {rowData.nome}
        {rowData.informacaoAdicional && ` - ${rowData.informacaoAdicional.toUpperCase()}`}
      </>
    );
  };

  const qtdBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Quantidade Pedida</span>
        <span>
          {rowData.quantidadeRequisitada}
          {' '}
          {rowData.unidade ? rowData.unidade : 'un'}
        </span>
      </>
    );
  };

  const consumoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Cons. Semana Anterior</span>
        <span>{rowData.consumosemanal}</span>
      </>
    );
  };

  const header = (
    <>
      <div className="table-header campo-filtro sticky">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={e => setGlobalFilter(e.target.value)}
            placeholder="Pesquise pela descrição dos campos..."
            style={{ width: '78vw', height: '6vh' }}
          />
        </span>
      </div>
    </>
  );

  const pt = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
    monthNames: [
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ],
    monthNamesShort: [
      'jan',
      'fev',
      'mar',
      'abr',
      'mai',
      'jun',
      'jul',
      'ago',
      'set',
      'out',
      'nov',
      'dez',
    ],
    today: 'Hoje',
    clear: 'Limpar',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Sm',
  };

  const headerCalendar = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <strong style={{ fontSize: 20, color: '#fff', marginBottom: 8 }}>
        Período das Requisições
      </strong>
      <Calendar
        locale={pt}
        value={dateRange}
        onChange={e => {
          setDateRange(e.value);
        }}
        dateFormat="dd/mm/yy"
        selectionMode="range"
        rangeColors={['#1976d2']}
        showIcon
        showButtonBar
        style={{
          width: '300px',
        }}
      />
    </div>
  );

  const dateInclusaoFilter = (
    <Calendar
      locale={pt}
      value={selectedDateInclusao}
      onChange={e => {
        setSelectedDateInclusao(e.value);
        if (e.value === null) {
          dt.current.filter(null, 'pedidoEm', 'notEquals');
          return;
        }
        dt.current.filter(
          new Date(e.value).toISOString().substring(0, 10),
          'pedidoEm',
          'startsWith'
        );
      }}
      dateFormat="dd/mm/yy"
      className="p-column-filter"
      placeholder="Data"
      showButtonBar
    />
  );

  const statusFilter = (
    <Autocomplete
      options={listaStatus}
      getOptionLabel={option => `${option}`}
      onChange={(e, value) => {
        setStatusSelecionado(value);
        dt.current.filter(value, 'status', 'equals');
      }}
      value={statusSelecionado}
      filterSelectedOptions
      renderInput={params => <TextField {...params} label="Status" variant="outlined" />}
    />
  );

  const rowExpansionTemplate = data => {
    return (
      <div className="datatable">
        <div style={{ display: 'flex' }}>
          <h5>{`Requisição Nº ${data.numero}`}</h5>
          <h5 style={{ marginLeft: 32 }}>
            {data.tipoRequisicao === 'S'
              ? 'Tipo Req.: Saída'
              : data.tipoRequisicao === 'D'
                ? 'Tipo Req.: Devolução'
                : 'Tipo Req.: Não informado'}
          </h5>
          <h5 style={{ marginLeft: 32 }}>
            {data.ramal ? `Ramal: ${data.ramal}` : 'Ramal: Não informado'}
          </h5>
        </div>
        <h5>
          {data.setorRequisitante
            ? `Setor Requisitante: ${data.setorRequisitante}`
            : 'Setor Requisitante: Não informado'}
        </h5>
        <h5>{data.observacao ? `Obs: ${data.observacao}` : 'Obs: Não informado'}</h5>
        <DataTable value={data.produtos} rows={4} paginator className="p-datatable-prime">
          <Column field="codigo" body={codigoBodyTemplate} header="Código" sortable />
          <Column field="nome" body={nomeBodyTemplate} header="Nome" sortable />
          <Column
            field="consumoSemanaAnterior"
            body={consumoBodyTemplate}
            header="Cons. Semana Anterior"
            sortable
          />
          <Column
            field="quantidadeRequisitada"
            body={qtdBodyTemplate}
            header="Quantidade Pedida"
            sortable
          />
        </DataTable>
      </div>
    );
  };

  const footerContent = (
    <div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={() => setOpenDialogRecusar(false)}
        className="p-button-text"
      />
      <Button
        label="Salvar"
        icon="pi pi-check"
        onClick={() => handleRecusarRequisicao()}
        autoFocus
      />
    </div>
  );

  return (
    <div id="laranja">
      <ModalAtender
        openDialogAtender={openDialogAtender}
        closeDialogAtender={closeDialogAtender}
        requisicao={requisicaoSelecionada}
      />

      <Dialog
        header="Recusar Requisição"
        visible={openDialogRecusar}
        style={{ width: '40vw' }}
        onHide={() => {
          if (!openDialogRecusar) return;
          setOpenDialogRecusar(false);
        }}
        footer={footerContent}
      >
        <InputTextarea
          type="text"
          maxLength={200}
          defaultValue={motivoRecusa}
          onInput={e => setMotivoRecusa(e.target.value)}
          placeholder="Digite o motivo da recusa"
          style={{ width: '100%', height: '80px', marginBottom: '12px' }}
        />
      </Dialog>

      <Dialog
        header="MOTIVO DE RECUSA"
        visible={openMotivoRecusa}
        style={{ width: '50vw' }}
        onHide={() => setOpenMotivoRecusa(false)}
      >
        <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {rowSelecionado?.motivoRecusa}
        </p>
      </Dialog>

      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <br />
          <Card>
            <CardHeader color="info" id="centroBIM" className="card-header">
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={6}>
                  <p className="card-title">
                    <strong>BIM</strong>
                  </p>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                >
                  {headerCalendar}
                </Grid>
              </Grid>
            </CardHeader>
            <CardBody className="card-body-0-padding">
              <div className="datatable">
                <div id="divAlmoxarifado">
                  <Autocomplete
                    id="almoxarifadoID"
                    options={profissional.almoxarifadosProfissional}
                    getOptionLabel={option => `${option.nome}`}
                    fullWidth
                    className={
                      profissional.almoxarifadosProfissional.length < 2 ? 'invisivel' : null
                    }
                    value={almoxarifadoSelecionado}
                    onChange={(e, value) => {
                      setAlmoxarifadoSelecionado(value);
                    }}
                    renderInput={params => (
                      <TextField {...params} label="Almoxarifado" variant="outlined" />
                    )}
                  />
                </div>
                <div className="card">
                  <DataTable
                    ref={dt}
                    value={requisicoes}
                    expandedRows={expandedRows}
                    onRowToggle={e => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    paginator
                    header={header}
                    globalFilter={globalFilter}
                    rows={10}
                    className="p-datatable-prime"
                    emptyMessage="Sem requisições"
                    loading={loading}
                    first={first}
                    onPage={e => {
                      setFirst(e.first);
                      document.location.href = `${document.location.href.replace(
                        '#centroBIM',
                        ''
                      )}#centroBIM`;
                    }}
                  >
                    <Column expander style={{ width: '3em' }} />
                    <Column
                      field="numero"
                      header="Código"
                      sortable
                      body={numeroBodyTemplate}
                      filter
                      filterPlaceholder="Código"
                      filterMatchMode="contains"
                      headerStyle={{ width: '10vw' }}
                    />
                    <Column
                      field="requisicaoPai.numero"
                      header="Req. Pai"
                      sortable
                      body={reqPaiBodyTemplate}
                      filter
                      filterPlaceholder="Req. Pai"
                      filterMatchMode="contains"
                      headerStyle={{ width: '10vw' }}
                    />
                    <Column
                      field="solicitante"
                      header="Solicitante"
                      sortable
                      body={solicitanteBodyTemplate}
                      filter
                      filterPlaceholder="Solicitante"
                      filterMatchMode="contains"
                      headerStyle={{ width: '20vw' }}
                    />
                    <Column
                      field="pedidoEm"
                      header="Data"
                      sortable
                      body={dataBodyTemplate}
                      filter
                      filterElement={dateInclusaoFilter}
                      filterFunction={() => filterDate()}
                    />
                    <Column
                      field="status"
                      header="Status"
                      sortable
                      body={statusBodyTemplate}
                      filter
                      filterElement={statusFilter}
                      headerStyle={{ width: '15vw' }}
                    />
                    <Column
                      header="Ações"
                      headerStyle={{ textAlign: 'center', width: '9vw' }}
                      body={acoesBodyTemplate}
                    />
                  </DataTable>
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
